export default {
  setItem (item){
    return localStorage.setItem(item.key , item.value);
  },
  getItem (item){
    return localStorage.getItem(item.key);
  },
  removeItem (item){
    return localStorage.removeItem(item.key);
  },
  clearAll (){
      return localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/lib/tool/storage/index.js